import React from "react";

const PrivacyPolicyHappyMemory: React.FC = () => {
    return (
        <div className="privacy-policy-text">
            <p>
                Tämä on <strong>Digihappy Memory Game</strong> -pelin tietosuojaseloste. Peli ei kerää, tallenna tai jaa mitään henkilötietoja käyttäjistä.
            </p>
            <p>Jos teet ostoksen Google Play -kaupan tai Applen App Storen (mukaan lukien Apple Pay) kautta, maksun käsittelee yksinomaan Google tai Apple. Emme vastaanota tai tallenna maksutietojasi.</p>
            <p>Sovelluksessa ei käytetä analytiikkaa, seurantatyökaluja eikä kolmannen osapuolen mainontaa.</p>
        </div>
    );
};

export default PrivacyPolicyHappyMemory;
